import bigQueryMetricRecorder from '../../v2/tracking/bigQueryMetricRecorder';
import Track from '../../v2/utils/tracking';

export default function trackDeliveryOptionsShown(deliveryResponse, isTaxableOptionShown,
  deliveryOptionsDays = []) {
  const getOptionIDsFromGroup = group => group.deliveryOptions.map(option => option.optionType || option.id);
  
  const allDeliveryOptions = deliveryResponse.deliveryGroups.flatMap(getOptionIDsFromGroup);
  
  const uniqueDeliveryOptions = Array.from(new Set(allDeliveryOptions));
  // REGRESSION. The following line was not being transpiled/polyfilled correctly by Corejs/Babel. We will raise a ticket with them.
  // const uniqueDeliveryOptions = [...new Set(allDeliveryOptions)];
  
  const deliveryOptionsShownAttributes = [
    ...uniqueDeliveryOptions.map(
      optionName => ({name: 'deliveryOption', value: optionName}),
    ),
    ...deliveryOptionsDays,
  ];
  
  deliveryOptionsShownAttributes.push({
    name: 'isSplitBasket',
    value: deliveryResponse.deliveryGroups.length > 1,
  });
  
  try {
    bigQueryMetricRecorder('deliveryOptionsShown', deliveryOptionsShownAttributes, [], 'impression');
    if (isTaxableOptionShown) {
      bigQueryMetricRecorder('taxableDeliveryOptionShown', [], [], 'impression');
    }
  } catch (error) {
    Track.track(error);
  }
}
